import { isArray } from 'lib';

/**
 * مقایسه دو آرایه
 * مقدار دومی حتما در اولی باید باشد وگرنه فالس میشه
 * @param {*} a آرایه اول
 * @param {*} b آرایه دوم
 * @returns مقدار true | false
 */
export const isEqualArray = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  const notFound = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < b.length; ++i) {
    if (!a.includes(b[i])) {
      notFound.push(b[i]);
    }
  }

  if (notFound.length) {
    return { isEqual: false, notEqual: notFound };
  }
  return { isEqual: true, notEqual: null };
};

export const isEqualResponse = (a, b) => {
  const { isEqual, notEqual } = isArray(a?.data)
    ? isEqualArray(Object.keys(a?.data[0]), b)
    : isEqualArray(Object.keys(a?.data), b);

  if (isEqual) {
    return a;
  }

  throw new Error('ResponseError: API response has changed', notEqual);
};
